import { render } from "./CheckinFamily.vue?vue&type=template&id=677ecc64&scoped=true"
import script from "./CheckinFamily.vue?vue&type=script&lang=js"
export * from "./CheckinFamily.vue?vue&type=script&lang=js"

import "./CheckinFamily.vue?vue&type=style&index=0&id=677ecc64&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677ecc64"]])

export default __exports__